import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import styled from 'styled-components';
import PreWorkGallery from './PreWorkGallery';

const TabWrapperStyles = styled.div`
  .tabHeader {
    display: flex;
    .headerItem {
      width: 100%;
      padding: 25px 0;
      border: 1px solid var(--black);
      border-radius: 0 !important;
      font-family: 'RobotoSlab';
      font-size: 20px;
      line-height: 30px;
      font-weight: 500;
      &.react-tabs__tab--selected {
        background: var(--black);
        color: var(--white);
      }
      text-align: center;
    }
  }
  .tabBox {
    padding: 40px;
    border: 1px solid var(--black);
    border-top: 0;
    :empty {
      display: none;
    }
  }
  @media (max-width: 767px) {
    width: calc(100% + 40px);
    margin-left: -20px;
    .tabHeader {
      .headerItem {
        padding: 10px;
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;
      }
    }
    .tabBox {
      padding: 20px;
    }
  }
`;

const PartsTableStyles = styled.div`
  display: table;
  width: 100%;
  border-collapse: collapse;

  .tableRow {
    display: table-row;
    border-bottom: 1px dashed var(--black);
    table-layout: fixed;
    > div {
      display: table-cell;
      padding: 10px 20px;
      text-align: left;
      vertical-align: middle;
      :first-child {
        width: 140px;
        padding-left: 0;
        text-align: left;
        figure,
        p {
          display: inline-block;
        }
      }
      :last-child {
        width: 140px;
        padding-right: 0;
      }
    }
    &.tableHead {
      border-bottom-style: solid;
      border-width: 3px;
      > div {
        padding-top: 0;
      }
    }
    h5 {
      font-size: 16px;
      line-height: 20px;
      color: var(--black);
      font-weight: 500;
    }
    p {
      font-family: 'RobotoSlab';
      font-size: 16px;
      line-height: 24px;
      color: #001926;
      span {
        font-size: 20px;
        line-height: 24px;
        font-weight: 500;
      }
    }
    :last-child {
      border-bottom: 0;
      > div {
        padding-bottom: 0;
      }
    }
  }
  @media (max-width: 767px) {
    .tableRow {
      > div {
        padding: 10px 5px;
        :first-child {
          width: 60px;
        }
        :last-child {
          width: 55px;
          h5,
          p {
            text-align: right;
          }
        }
      }
      h5 {
        font-size: 12px;
        line-height: 14px;
      }
      p span {
        font-size: 14px;
        line-height: 18px;
      }
    }
  }
`;

const GalleryStyles = styled.div`
  border: 1px solid var(--black);
  div {
    margin-top: 0;
    zoom: unset !important;
  }
  .myThumb {
    display: flex;
    width: 100%;
    border-top: 1px solid var(--black);
    > div {
      display: flex;
      width: 100px;
      min-height: 100px;
      background: var(--black);
      justify-content: center;
      align-items: center;
      span {
        font-family: 'RobotoSlab';
        font-size: 42px;
        line-height: 44px;
        color: var(--white);
      }
    }
    article {
      display: flex;
      width: calc(100% - 100px);
      padding: 20px;
      align-items: center;
      p {
        font-family: 'RobotoSlab';
        font-size: 16px;
        line-height: 22px;
        color: var(--black);
      }
    }
  }
  .galleryNav {
    width: 60px;
    height: 60px;
    margin: 10px;
  }
  @media (max-width: 767px) {
    .myThumb {
      > div {
        width: 40px;
        min-height: 40px;
        span {
          font-size: 18px;
          line-height: 20px;
        }
      }
      article {
        display: flex;
        width: calc(100% - 40px);
        padding: 10px;
        p {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
    .galleryNav {
      width: 40px;
      height: 40px;
    }
  }
`;

const VideoWrapperStyles = styled.div`
  overflow: hidden;
  position: relative;
  max-width: 100%;
  height: 0;
  padding-bottom: 56.25%;

  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    background-color: black;
  }
`;

export default function CustomTab({ parts, gallery, video }) {
  return (
    <TabWrapperStyles>
      <Tabs>
        <TabList className="tabHeader">
          {parts && parts.length > 0 ? (
            <Tab className="headerItem">parts</Tab>
          ) : null}
          {gallery && gallery.length > 0 ? (
            <Tab className="headerItem">steps</Tab>
          ) : null}
          {video ? <Tab className="headerItem">video</Tab> : null}
        </TabList>
        {parts && parts.length > 0 ? (
          <TabPanel className="tabBox">
            <PartsTableStyles>
              <div className="tableRow tableHead">
                <div>
                  <h5>image</h5>
                </div>
                <div>
                  <h5>name</h5>
                </div>
                <div>
                  <h5>quantity</h5>
                </div>
              </div>
              {parts.map((item, index) => (
                <div key={index} className="tableRow">
                  <div>
                    <figure>
                      <img src={item.image} alt={item.name} />
                    </figure>
                  </div>
                  <div>
                    <p>
                      <span>{item.name}</span>
                      <br />
                      {item.article_number}
                    </p>
                  </div>
                  <div>
                    <p>
                      <span>{item.quantity}</span>
                    </p>
                  </div>
                </div>
              ))}
            </PartsTableStyles>
          </TabPanel>
        ) : null}
        {gallery && gallery.length > 0 ? (
          <TabPanel className="tabBox">
            <GalleryStyles>
              <PreWorkGallery gallery={gallery} />
            </GalleryStyles>
          </TabPanel>
        ) : null}
        {video ? (
          <TabPanel className="tabBox">
            <VideoWrapperStyles>
              <iframe
                src={video}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </VideoWrapperStyles>
          </TabPanel>
        ) : null}
      </Tabs>
    </TabWrapperStyles>
  );
}
